var amdi18n={"__root":{"PLEASE_ALLOW_POPUPS":"Please allow popups for the Trebble FM site","OOPS_SOMETHING_WENT_WRONG":"Oops! something went wrong","LOVE":"Love","CAPSULE":"the content","SONG":"the song","YOU_JUST_LISTENED_FROM":"you just listened from","SHARE":"Share","REPLY":"Reply","SUBSCRIBE":"Subscribe","UP_NEXT_IN":"Up next in","CANCEL":"Cancel"},"__fr":{"PLEASE_ALLOW_POPUPS":"Veuillez autoriser les popups pour le site Trebble FM","OOPS_SOMETHING_WENT_WRONG":"Oops! quelque chose s'est mal passé","LOVE":"Vous avez aimé","CAPSULE":"le contenu","SONG":"la chanson","YOU_JUST_LISTENED_FROM":"que vous venez d'écouter","SHARE":"Partager","REPLY":"Répondre","SUBSCRIBE":"S'abonner","UP_NEXT_IN":"La suite dans","CANCEL":"Annuler"},"__en":{"PLEASE_ALLOW_POPUPS":"Please allow popups for the Trebble FM site","OOPS_SOMETHING_WENT_WRONG":"Oops! something went wrong","LOVE":"Love","CAPSULE":"the content","SONG":"the song","YOU_JUST_LISTENED_FROM":"you just listened from","SHARE":"Share","REPLY":"Reply","SUBSCRIBE":"Subscribe","UP_NEXT_IN":"Up next in","CANCEL":"Cancel"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(typeof window !== 'undefined' && window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(typeof document !== 'undefined' && document.documentElement.lang){
				language = document.documentElement.lang;
			}else if(typeof navigator !== 'undefined' && (navigator.languages || navigator.language || navigator.userLanguage)){
				// navigator.languages does not exist in IE 11
				language = (navigator.languages && navigator.languages[0]) ||
					navigator.language ||
					navigator.userLanguage;
				language = (language || 'root').toLowerCase();
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		var recursiveFallback = function(target, source){
			for(var name in source){
				switch(typeof target[name]){
				case 'undefined':
					target[name] = source[name];
					break;
				case 'object':
					recursiveFallback(target[name], source[name]);
				}
			}
		};
		recursiveFallback(this, this.__root);
	};amdi18n.init();module.exports=amdi18n;